import React from "react";
import { Form, Field } from 'react-final-form'
import PropTypes from "prop-types";
import InputField from "../fields/InputField";
import {composeValidators, required} from "../../helpers/ValidateHelper";
import Error from "../fields/Error";

function ResetPasswordCodeForm({onSubmit, onBack, email}) {
    return <Form onSubmit={onSubmit}>
        {({handleSubmit, submitting}) => (
            <form id="reset-password-active-form" onSubmit={handleSubmit} className="form-validation">
                <div className="form-group">
                    <p className="control-descr">We sent a 6-digit code to <strong>{email}</strong>. Please enter it below.</p>
                    <div className="form-label">Code <span className="rq">*</span></div>
                    <Field
                        name="code"
                        component={InputField}
                        placeholder="Enter 6-digit code"
                        className="control-input"
                        inputProps={{
                            inputMode: 'numeric',
                            maxLength: 6,
                            autoComplete: 'one-time-code',
                        }}
                        validate={composeValidators(
                            required('Please enter the code'),
                            value => value && !/^\d{6}$/.test(value) ? 'Code must be 6 digits' : undefined
                        )}
                    />
                    <Error name="code" />
                </div>
                <div className="form-btn_v3">
                    <button className="btn_v3 btn_v3-md btn_v3-primary" disabled={submitting}>
                        {submitting ? 'Verifying...' : 'Verify Code'}
                    </button>
                </div>
                <p className="control-descr">
                    <a href="#" onClick={e => { e.preventDefault(); onBack(); }}>Back</a>
                </p>
            </form>
        )}
    </Form>
}

ResetPasswordCodeForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
}

export default ResetPasswordCodeForm;
